export default __webpack_public_path__ + "static/media/gallery_11.9c26ecd5.jpg";